/* eslint-disable import/prefer-default-export */

/**
 * Destination names
 */
export let DestinationName = /*#__PURE__*/function (DestinationName) {
  DestinationName["DRIP"] = "DRIP";
  DestinationName["FACEBOOK_PIXEL"] = "FACEBOOK_PIXEL";
  DestinationName["GA4"] = "GA4";
  DestinationName["HOTJAR"] = "HOTJAR";
  DestinationName["POSTHOG"] = "POSTHOG";
  DestinationName["RUDDERSTACK"] = "RUDDERSTACK";
  DestinationName["SENTRY"] = "SENTRY";
  return DestinationName;
}({});